/**
 * Nhãn tiếng Việt của trường dữ liệu dùng chung cho thông báo lỗi (API + web), 03/11/2026.
 * Không bao giờ hiện tên thuộc tính / cột trong code cho người dùng.
 */

/** Nhãn tiếng Việt của trường (tên cột snake_case hoặc thuộc tính camelCase) */
export const FIELD_LABELS: Record<string, string> = {
  customer: 'Khách hàng',
  product: 'Sản phẩm',
  material: 'Vật tư',
  vendor: 'Nhà cung cấp',
  supplier: 'Nhà cung cấp',
  warehouse: 'Kho',
  location: 'Vị trí kệ',
  machine: 'Máy',
  process: 'Công đoạn',
  routing_step: 'Công đoạn',
  production_order: 'Lệnh sản xuất',
  order: 'Đơn hàng',
  order_detail: 'Dòng đơn hàng',
  quotation: 'Báo giá',
  quotation_detail: 'Dòng báo giá',
  purchase_order: 'Đơn mua hàng',
  outsource_order: 'Đơn gia công',
  delivery: 'Phiếu giao hàng',
  delivery_note: 'Phiếu giao hàng',
  layout: 'Bài bình',
  print_layout: 'Bài bình',
  mold: 'Khuôn',
  die_cut: 'Khuôn bế',
  plate: 'Bản kẽm',
  product_type: 'Loại sản phẩm',
  material_type: 'Loại vật tư',
  category: 'Danh mục',
  unit: 'Đơn vị tính',
  user: 'Người dùng',
  owner: 'Người phụ trách',
  sales_person: 'Nhân viên kinh doanh',
  salesperson: 'Nhân viên kinh doanh',
  sales_rep: 'Nhân viên kinh doanh',
  inspector: 'Người kiểm tra',
  operator: 'Thợ đứng máy',
  created_by: 'Người tạo',
  role: 'Vai trò',
  department: 'Phòng ban',
  qc_material: 'Phiếu IQC',
  qc_process: 'Phiếu IPQC',
  qc_final: 'Phiếu FQC',
  ncr: 'Phiếu NCR',
  packing_slip: 'Phiếu đóng gói',
  receipt: 'Phiếu thu',
  quantity: 'Số lượng',
  qty: 'Số lượng',
  unit_price: 'Đơn giá',
  price: 'Đơn giá',
  delivery_date: 'Ngày giao',
  due_date: 'Hạn giao',
  name: 'Tên',
  code: 'Mã',
  email: 'Email',
  phone: 'Số điện thoại',
  tax_code: 'Mã số thuế',
  status: 'Trạng thái',
};

const toSnake = (s: string) => s.replace(/([a-z0-9])([A-Z])/g, '$1_$2').toLowerCase();

/** Nhãn của 1 trường: bỏ hậu tố _id / Id, khớp đúng tên hoặc phần đuôi dài nhất (VD orders_customer_id → customer) */
export function fieldLabel(raw: string): string | undefined {
  const key = toSnake(String(raw)).replace(/_ids?$/, '');
  if (FIELD_LABELS[key]) return FIELD_LABELS[key];
  const parts = key.split('_');
  for (let i = 1; i < parts.length; i++) {
    const tail = parts.slice(i).join('_');
    if (FIELD_LABELS[tail]) return FIELD_LABELS[tail];
  }
  return undefined;
}
